/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

const Home = lazy(() => import('./pages/Home'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const BlogDashboard = lazy(() => import('./pages/BlogDashboard'));
const BlogPost = lazy(() => import('./pages/BlogPost'));
const ConfirmSubscription = lazy(() => import('./pages/ConfirmSubscription'));
const Unsubscribe = lazy(() => import('./pages/Unsubscribe'));

export default function App() {
  const isSiteEnabled = import.meta.env.VITE_SITE_ENABLED !== 'false';

  if (!isSiteEnabled) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center p-8 bg-white shadow-lg rounded-lg">
          <h1 className="text-4xl font-bold mb-4">Under Maintenance</h1>
          <p className="text-lg mb-4">This site is currently offline. Please check back later.</p>
          <p className="text-base text-gray-600">
            For any questions or interest, please contact:{' '}
            <a
              href="mailto:hello@nyrenehaquemd.com"
              className="text-blue-600 hover:text-blue-800 font-semibold"
            >
              hello@nyrenehaquemd.com
            </a>
          </p>
        </div>
      </div>
    );
  }

  return (
    <Suspense
      fallback={
        <div className="min-h-screen flex items-center justify-center bg-[#FCFCFC]">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-soft-teal" />
        </div>
      }
    >
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<BlogDashboard />} />
        <Route path="/blog/:id" element={<BlogPost />} />
        <Route path="/confirm" element={<ConfirmSubscription />} />
        <Route path="/unsubscribe" element={<Unsubscribe />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Suspense>
  );
}
